import { ConfirmPaymentAndPollOptions, PaymentAPI, PaymentState } from '../../typings/Payment'
import confirmPayment from './confirm-payment'
import pollPayment from './poll-payment'

const confirmPaymentAndPoll = async (
  paymentAPI: PaymentAPI,
  { orderId, options, lastPaymentAttempt }: ConfirmPaymentAndPollOptions,
) => {
  if (!options.savedPaymentMethodId) {
    throw new Error('Confirm payment was called without saved payment method ID')
  }

  const confirmPaymentResult = await confirmPayment(paymentAPI, {
    paymentId: options.payment.id,
    pspPaymentMethodId: options.savedPaymentMethodId,
  })

  if (confirmPaymentResult.__typename === 'ExpectedErrors') {
    return { wasSuccessful: false, error: confirmPaymentResult.errors[0].message }
  }

  // the payment state can either transition to
  // - `ON_HOLD` if a mandate was created initially or to
  // - `IN_PROGRESS` if the verified mandate is charge immediately
  return pollPayment(paymentAPI, {
    orderId,
    lastPaymentAttempt,
    additionalExpectedPaymentStates: [PaymentState.PAYMENT_STATE_ON_HOLD, PaymentState.PAYMENT_STATE_IN_PROGRESS],
  })
}

export default confirmPaymentAndPoll
